module.exports = __webpack_public_path__ + "img/SKWINKELNetActieDraaiboekCA526C.e29ee5c6.png";